import { useLocation, useHistory } from 'react-router-dom';
import { useState, useRef } from 'react';
import { Storage } from '@capacitor/storage';
import { IonItem, IonGrid, IonRow, IonCol, IonImg, IonIcon, IonButton } from '@ionic/react';
import { checkmark } from 'ionicons/icons';
import { Constants } from '../../defines/Constants';
import { FormatDate, FormatTime } from '../../defines/Functions';
import FlightDetails from './modals/FlightDetails';
import FlightPriceDetails from './modals/FlightPriceDetails';
import FlightRules from './modals/FlightRules';
import CurrencyFormat from 'react-currency-format';
import './FlightCard.css';
import planeImg from '../../assets/images/flight-card-plane.svg';

interface Props {
    data: any,
    id: number,
    flightDefines: any,
    searchType: string,
    expireTime?: any
}

const FlightCard = (item: Props) => {
    const [config, setConfig] = useState({}) as any;
    const configRef = useRef(false);
    const getConfig = async () => {
        if (!configRef.current) {
            const { value } = await Storage.get({ key: 'config' });
            if (value) {
                const objectValue = JSON.parse(value);
                setConfig(objectValue);
            } else {
                setConfig({});
            }
        }
        configRef.current = true;
    }
    getConfig();

    const location = useLocation();
    const currentPage = location.pathname;
    const history = useHistory();
    const onReserveClick = () => {
        history.push({
            pathname: '/flight/reservation',
            state: item
        });
    }

    return (
        <IonItem className="flight-card-item" lines="none">

            {item.data !== null &&
                <IonGrid>

                    {item.searchType !== 'multiple' ?
                        <>

                            <IonRow className="row-1">
                                {config && config.flight_type !== 'none' && config.flight_type === 'both' &&
                                    <span className={"price-type-label " + (item.data.priceType === "Charter" ? 'charter' : 'system')}>
                                        {item.data.priceType === 'Charter' ? 'چارتر' : 'سیستمی'}
                                    </span>
                                }

                                {config && config.flight_type === 'domestic-only' && item.flightDefines.targetName === 'Domestic' &&
                                    <span className={"price-type-label " + (item.data.priceType === "Charter" ? 'charter' : 'system')}>
                                        {item.data.priceType === 'Charter' ? 'چارتر' : 'سیستمی'}
                                    </span>
                                }

                                {config && config.flight_type === 'international-only' && item.flightDefines.targetName === 'international' &&
                                    <span className={"price-type-label " + (item.data.priceType === "Charter" ? 'charter' : 'system')}>
                                        {item.data.priceType === 'Charter' ? 'چارتر' : 'سیستمی'}
                                    </span>
                                }

                                <IonCol size="2" className="col-1 ion-text-center">
                                    <IonImg src={Constants.airlines + item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].operatingAirline.code + '.png'} />
                                    <span>
                                        {item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].airlinePersian ? (
                                            item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].airlinePersian
                                        ) : (
                                            item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].operatingAirline.companyShortName
                                        )}
                                    </span>
                                </IonCol>
                                <IonCol size="3" className="col-2 ion-text-center">
                                    <h5>
                                        {FormatTime(item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureDateTime, "hh:mm")}
                                    </h5>
                                    <span>
                                        {item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].departureCityPersian ? (
                                            item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].departureCityPersian
                                        ) : (
                                            item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].departureCity
                                        )}
                                    </span>
                                </IonCol>
                                <IonCol size="4" className="col-3 ion-text-center">

                                    {item.flightDefines.targetName !== 'Domestic' &&
                                        <span>
                                            {item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment.length === 1 ? (
                                                'بدون توقف'
                                            ) : (
                                                item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment.length - 1 + ' - توقف'
                                            )}
                                        </span>
                                    }

                                    {item.flightDefines.targetName === 'Domestic' && item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].aircraftName &&
                                        <span className="aircraftName">
                                            {item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].aircraftName}
                                        </span>
                                    }
                                    <IonImg src={planeImg} />
                                    <span>
                                        {FormatDate(item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureDateTime, 'jD jMMMM')}
                                    </span>
                                </IonCol>
                                <IonCol size="3" className="col-4 ion-text-center">
                                    <h5>
                                        {FormatTime(item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment.length - 1].arrivalDateTime, "hh:mm")}
                                    </h5>
                                    <span>
                                        {item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment.length - 1].tpaextensions.any[0].arrivalCityPersian ? (
                                            item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment.length - 1].tpaextensions.any[0].arrivalCityPersian
                                        ) : (
                                            item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment.length - 1].tpaextensions.any[0].arrivalCity
                                        )}
                                    </span>
                                </IonCol>
                            </IonRow>
                            {item.searchType === 'roundtrip' &&
                                <IonRow className="row-1">
                                    <IonCol size="2" className="col-1 ion-text-center">
                                        <IonImg src={Constants.airlines + item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].operatingAirline.code + '.png'} />
                                        <span>
                                            {item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].airlinePersian ? (
                                                item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].airlinePersian
                                            ) : (
                                                item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].operatingAirline.companyShortName
                                            )}
                                        </span>
                                    </IonCol>
                                    <IonCol size="3" className="col-2 ion-text-center">
                                        <h5>
                                            {FormatTime(item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].departureDateTime, "hh:mm")}
                                        </h5>
                                        <span>
                                            {item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].departureCityPersian ? (
                                                item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].departureCityPersian
                                            ) : (
                                                item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].departureCity
                                            )}
                                        </span>
                                    </IonCol>
                                    <IonCol size="4" className="col-3 ion-text-center">

                                        {item.flightDefines.targetName !== 'Domestic' &&
                                            <span>
                                                {item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment.length === 1 ? (
                                                    'بدون توقف'
                                                ) : (
                                                    item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment.length - 1 + ' - توقف'
                                                )}
                                            </span>
                                        }
                                        {item.flightDefines.targetName === 'Domestic' && item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].aircraftName &&
                                            <span className="aircraftName">
                                                {item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].aircraftName}
                                            </span>
                                        }

                                        <IonImg src={planeImg} />
                                        <span>
                                            {FormatDate(item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].departureDateTime, 'jD jMMMM')}
                                        </span>
                                    </IonCol>
                                    <IonCol size="3" className="col-4 ion-text-center">
                                        <h5>
                                            {FormatTime(item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment.length - 1].arrivalDateTime, "hh:mm")}
                                        </h5>
                                        <span>
                                            {item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment.length - 1].tpaextensions.any[0].arrivalCityPersian ? (
                                                item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment.length - 1].tpaextensions.any[0].arrivalCityPersian
                                            ) : (
                                                item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[item.data.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment.length - 1].tpaextensions.any[0].arrivalCity
                                            )}
                                        </span>
                                    </IonCol>
                                </IonRow>
                            }
                        </>
                        :
                        item.data.airItinerary.originDestinationOptions.originDestinationOption.map((originDestinationOption: any, index: number) =>
                            <IonRow className="row-1" key={"index" + index}>
                                <IonCol size="2" className="col-1 ion-text-center">
                                    <IonImg src={Constants.airlines + originDestinationOption.flightSegment[0].operatingAirline.code + '.png'} />
                                    <span>
                                        {originDestinationOption.flightSegment[0].tpaextensions.any[0].airlinePersian ? (
                                            originDestinationOption.flightSegment[0].tpaextensions.any[0].airlinePersian
                                        ) : (
                                            originDestinationOption.flightSegment[0].operatingAirline.companyShortName
                                        )}
                                    </span>
                                </IonCol>
                                <IonCol size="3" className="col-2 ion-text-center">
                                    <h5>
                                        {FormatTime(originDestinationOption.flightSegment[0].departureDateTime, "hh:mm")}
                                    </h5>
                                    <span>
                                        {originDestinationOption.flightSegment[0].tpaextensions.any[0].departureCityPersian ? (
                                            originDestinationOption.flightSegment[0].tpaextensions.any[0].departureCityPersian
                                        ) : (
                                            originDestinationOption.flightSegment[0].tpaextensions.any[0].departureCity
                                        )}
                                    </span>
                                </IonCol>
                                <IonCol size="4" className="col-3 ion-text-center">
                                    {item.flightDefines.targetName !== 'Domestic' &&
                                        <span>
                                            {originDestinationOption.flightSegment.length === 1 ? (
                                                'بدون توقف'
                                            ) : (
                                                originDestinationOption.flightSegment.length - 1 + ' - توقف'
                                            )}
                                        </span>
                                    }

                                    {item.flightDefines.targetName === 'Domestic' && originDestinationOption.flightSegment[0].tpaextensions.any[0].aircraftName &&

                                        <span className="aircraftName">
                                            {originDestinationOption.flightSegment[0].tpaextensions.any[0].aircraftName}
                                        </span>
                                    }

                                    <IonImg src={planeImg} />
                                    <span>
                                        {FormatDate(originDestinationOption.flightSegment[0].departureDateTime, 'jD jMMMM')}
                                    </span>
                                </IonCol>
                                <IonCol size="3" className="col-4 ion-text-center">
                                    <h5>
                                        {FormatTime(originDestinationOption.flightSegment[originDestinationOption.flightSegment.length - 1].arrivalDateTime, "hh:mm")}
                                    </h5>
                                    <span>
                                        {originDestinationOption.flightSegment[originDestinationOption.flightSegment.length - 1].tpaextensions.any[0].arrivalCityPersian ? (
                                            originDestinationOption.flightSegment[originDestinationOption.flightSegment.length - 1].tpaextensions.any[0].arrivalCityPersian
                                        ) : (
                                            originDestinationOption.flightSegment[originDestinationOption.flightSegment.length - 1].tpaextensions.any[0].arrivalCity
                                        )}
                                    </span>
                                </IonCol>
                            </IonRow>
                        )
                    }
                    <IonRow className="row-2">
                        <IonCol size="6" className="col-1">
                            <div className="amountContainer">
                                {(item.data.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount !== item.data.airItineraryPricingInfo.itinTotalFare[0].totalFare.amount &&
                                    item.data.airItineraryPricingInfo.itinTotalFare[0].totalFare.amount > item.data.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount) &&
                                    <del>
                                        <CurrencyFormat value={item.data.airItineraryPricingInfo.itinTotalFare[0].totalFare.amount} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                    </del>
                                }
                                <b>
                                    <CurrencyFormat value={item.data.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                </b>
                                {
                                    config &&
                                        config.flight_type &&
                                        (config.flight_type === "both" || config.flight_type === "domestic-only") &&
                                        item.flightDefines.targetName &&
                                        item.flightDefines.targetName === "Domestic" &&
                                        item.data.priceType !== "Charter"
                                        ? (
                                            <span>
                                                نرخ رسمی ایرلاین
                                            </span>
                                        ) : (
                                            null
                                        )
                                }
                            </div>
                        </IonCol>
                        {currentPage === '/flight/reservation' ? (
                            null
                        ) : (
                            <IonCol size="6" className="col-2">
                                <IonButton color="warning" expand="block" onClick={onReserveClick}>
                                    رزرو بلیط
                                    <IonIcon icon={checkmark} />
                                </IonButton>
                            </IonCol>
                        )}
                    </IonRow>
                    <IonRow className="row-3">
                        <IonCol size="4" className="ion-text-center col-1">
                            <FlightDetails data={item.data} flightDefines={item.flightDefines} searchType={item.searchType} />
                        </IonCol>
                        <IonCol size="4" className="ion-text-center col-2">
                            <FlightPriceDetails data={item.data} />
                        </IonCol>
                        <IonCol size="4" className="ion-text-center col-3">
                            <FlightRules data={item.data} flightDefines={item.flightDefines} />
                        </IonCol>
                    </IonRow>
                </IonGrid>
            }
        </IonItem>
    );
};
export default FlightCard;